import { Badge, Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { updateDrawer } from "../../../store/actions/miscAction";
import {
  formatDelay,
  formatTimestamp,
  getDelayValue,
  getDeliveryState,
  getMessageTimeline,
  getProviderName,
  getProviderStatusLabel,
} from "../../../utils/smsDelays";

const MessagesTable = ({ messages }) => {
  const dispatch = useDispatch();
  const openDrawer = (id) => {
    const drawer = {
      title: "Message Details",
      isOpen: 1,
      content: { component: "MessageCard", id },
    };
    dispatch(updateDrawer(drawer));
  };

  return (
    <Box overflowX="auto">
      <Table size="sm" className="stripedTable">
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Received</Th>
            <Th>Sent Time</Th>
            <Th>Delivered</Th>
            <Th>Phone Number</Th>
            <Th>Message</Th>
            <Th>Provider</Th>
            <Th>Provider Status</Th>
            <Th>Provider Message ID</Th>
            <Th>Provider Updated</Th>
            <Th>Delivery Status</Th>
            <Th isNumeric>Queue Delay</Th>
            <Th isNumeric>Delivery Delay</Th>
            <Th isNumeric>Total Delay</Th>
          </Tr>
        </Thead>
        <Tbody>
          {messages.map((message, i) => {
            const { mobile } = message;
            const timeline = getMessageTimeline(message);
            const deliveryState = getDeliveryState(message);
            return (
              <Tr key={message.id} onClick={() => openDrawer(message.id)} cursor="pointer">
                <Td>{i + 1}</Td>
                <Td>{formatTimestamp(timeline.received)}</Td>
                <Td>{formatTimestamp(timeline.sent || message.created)}</Td>
                <Td>{formatTimestamp(timeline.delivered)}</Td>
                <Td>{mobile}</Td>
                <Td>{message.message}</Td>
                <Td>{getProviderName(message)}</Td>
                <Td>{getProviderStatusLabel(message)}</Td>
                <Td>{message.providerMessageId || "N/A"}</Td>
                <Td>{formatTimestamp(timeline.providerUpdated)}</Td>
                <Td>
                  <Badge colorScheme={deliveryState.colorScheme}>{deliveryState.label}</Badge>
                </Td>
                <Td isNumeric>{formatDelay(getDelayValue(message, "queueDelaySeconds"))}</Td>
                <Td isNumeric>{formatDelay(getDelayValue(message, "deliveryDelaySeconds"))}</Td>
                <Td isNumeric>{formatDelay(getDelayValue(message, "totalDelaySeconds"))}</Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};

export default MessagesTable;
